// Reserve with Google (RwG)
// Conversion tracking utils

import axios from 'axios'

const PARTNER_ID = '20002000'
const TOKEN_PARAM = 'rwg_token'
const RWG_TOKEN_COOKIE_NAME = '_rwg_token'

const getRwgTokenFromUrl = (): string => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(TOKEN_PARAM)
}

const setRwgTokenInCookie = (rwgToken: string): void => {
  const domain = window.location.hostname
  document.cookie = `${RWG_TOKEN_COOKIE_NAME}=${rwgToken};_merchant_id=${PARTNER_ID};max-age=2592000;domain=${domain};path=/`
}

const getRwgTokenFromCookie = (): string => {
  const rwgTokenCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${RWG_TOKEN_COOKIE_NAME}=`))
  return rwgTokenCookie ? rwgTokenCookie.split('=')[1] : ''
}

// Capture RwG token from URL if available and set it in cookie
export const handleCaptureRwgToken = (): void => {
  const rwgToken = getRwgTokenFromUrl()

  if (rwgToken) {
    setRwgTokenInCookie(rwgToken)
  }
}

// Send RwG conversion data
export const handleSendRwgConversionData = (): void => {
  const rwgToken = getRwgTokenFromCookie()
  const url = process.env.NEXT_PUBLIC_RWG_CONVERSION_URL

  if (!rwgToken || !url) {
    return
  }

  const payload = {
    conversion_partner_id: PARTNER_ID,
    merchant_changed: 2,
    rwg_token: rwgToken,
  }

  // NOTE This `url` is an endpoint that does not accept preflight requests with the OPTIONS method.
  // So we need to send the request with the `Content-Type` header set to `text/plain` to make the AJAX a "simple request".
  axios
    .post(url, JSON.stringify(payload), {
      headers: { 'Content-Type': 'text/plain' },
    })
    .catch(() => {
      // Fail gracefully. If there is an AJAX error here, we don't want that to break the booking page.
    })
}
